import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Nunito Sans is self-hosted rather than loaded from a font CDN: the archive has to
// stay readable without a third-party request, and it keeps the CSP's font-src at 'self'.
import '@fontsource/nunito-sans/latin-400.css'
import '@fontsource/nunito-sans/latin-600.css'
import '@fontsource/nunito-sans/latin-700.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
